import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// 新站内容包（cy 命名空间）：英文全量，中文仅全局层，缺失回退英文。
// 旧的 translation.json（含已禁用的规模/回报主张与模板文案）不再加载。
import cyEN from './content/en';
import cyZH from './content/zh';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { cy: cyEN },
      zh: { cy: cyZH }
    },
    // 使用浏览器的语言设置，如果是中文则默认为中文，否则为英文
    lng: navigator.language.startsWith('zh') ? "zh" : "en",
    fallbackLng: "en",
    ns: ['cy'],
    defaultNS: 'cy',

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
